import clsx from "clsx";
import { Command } from "cmdk";
import { Checkbox } from "../../../checkbox/Checkbox";
import { selectedAll, selectItem } from "../../common/Select.css";
import { Option } from "../../common/SelectBase";
import { useSelectMultiple } from "../hooks/useSelectMultiple";

interface SelectHeaderActionsProps {
  /**
   * Currently selected values
   */
  value: string[];

  /**
   * Options currently filtered in the select dropdown
   */
  filteredOptions: Option[];
  /**
   * Callback fired when selection changes
   */
  onChange: (value: string[]) => void;
}

export function SelectHeaderActions({
  value,
  filteredOptions,
  onChange
}: SelectHeaderActionsProps) {
  const {
    allSelected,
    relevantSelected,
    toggleAllFiltered: toggleSelected,
    displayText
  } = useSelectMultiple(value ?? [], filteredOptions, onChange);

  return (
    <Command.Group>
      <Command.Item
        onSelect={toggleSelected}
        className={clsx(selectItem, selectedAll)}
        aria-checked={allSelected}
        role="option"
        tabIndex={-1}
      >
        <Checkbox
          checked={allSelected || relevantSelected}
          indeterminate={relevantSelected && !allSelected}
          onChange={toggleSelected}
        />
        {displayText}
      </Command.Item>
    </Command.Group>
  );
}
